/**
 * 我的分析
 */
export default {
  dbl_myAnalysis_title: "Chart Center",
  dbl_myAnalysis_new: "Add Chart",
  dbl_myAnalysis_search_task: "Search task name",
  dbl_myAnalysis_task_permissions: "Task Permissions",
  dbl_myAnalysis_visible_to_me_only: "Visible to Me Only",
  dbl_myAnalysis_visible_to_business: "Visible to Business",
  dbl_myAnalysis_task_tags: "Chart Tags",
  dbl_myAnalysis_table_task_tags: "Chart Tags",
  dbl_myAnalysis_task_name: "Task Name",
  dbl_myAnalysis_task_permission: "Task Permissions",
  dbl_myAnalysis_status: "Status",
  dbl_myAnalysis_creation_time: "Create Time",
  dbl_myAnalysis_person_in_charge: "Person in Charge",
  dbl_myAnalysis_actions: "Actions",
  dbl_myAnalysis_edit: "Edit",
  dbl_myAnalysis_view: "View",
  dbl_myAnalysis_publish: "Publish",
  dbl_myAnalysis_share: "Share",
  dbl_myAnalysis_delete: "Delete",
  dbl_myAnalysis_copy_chart_title: "Copy Chart",
  dbl_myAnalysis_copy_success: "Copy successful",
  dbl_myAnalysis_copy_fail: "Copy failed, error code: {code}",
  dbl_myAnalysis_total: "Total {total} Items",
  dbl_myAnalysis_share_success: "Share Success",
  dbl_myAnalysis_delete_success: "Delete Success",
  dbl_myAnalysis_published: "Published",
  dbl_myAnalysis_unpublished: "Unpublished",
  // 发布设置弹窗
  dbl_myAnalysis_publish_set: "Publish Settings",
  dbl_myAnalysis_publish_filter_default: "Filter default settings",
  dbl_myAnalysis_publish_detail: "Publishing details settings",
  dbl_myAnalysis_publish_dashboard_en: "Report English Name",
  dbl_myAnalysis_publish_dashboard_en_placeholder: "Please enter the English name of the report",
  dbl_myAnalysis_publish_dashboard_zh: "Report Chinese Name",
  dbl_myAnalysis_publish_dashboard_zh_placeholder: "Please enter the Chinese name of the report",
  dbl_myAnalysis_publish_first_level_dir: "Primary directory",
  dbl_myAnalysis_publish_second_level_dir: "Secondary directory",
  dbl_myAnalysis_publish_second_level_dir_placeholder: "Property Catalog Selection",
  dbl_myAnalysis_publish_dashboard_task: "Report label",
  dbl_myAnalysis_publish_dashboard_task_placeholder: "Label selection",
  dbl_myAnalysis_publish_person: "Publisher",
  dbl_myAnalysis_publish_valid_length: "Cannot be empty and the length is not more than 80",
  dbl_myAnalysis_publish_valid_first_dir: "Please select a first-level directory",
  dbl_myAnalysis_publish_valid_second_dir: "Please select a secondary directory",
  dbl_myAnalysis_publish_valid_task: "Please select a report label",
  dbl_myAnalysis_publish_success: "Publishing succeeded",
  dbl_myAnalysis_publish_view_detail: "View details",
  dbl_myAnalysis_publish_nothing: "No filter settings",
  dbl_myAnalysis_publish_select_info: "Display deduplicated  user data of all zone_id",
  dbl_myAnalysis_publish_select_aggregating: "Aggregating",
  // 删除提示
  dbl_myAnalysis_delete_title: "Are you sure to delete the task?",
  dbl_myAnalysis_delete_message: " will cause the analysis task to become unusable and the deletion task cannot be restored. Please operate with caution.",

  dbl_myAnalysis_lable: 'Label',
  dbl_myAnalysis_chart_name: 'Chart Name',
  dbl_myAnalysis_chart_type: 'Chart Type',
  dbl_myAnalysis_chart_data_source: 'Data Source',
  dbl_myAnalysis_chart_creator: 'Creator',
  dbl_myAnalysis_operation: 'Actions',
  dbl_myAnalysis_create_new_chart: 'Create New Chart',
  dbl_myAnalysis_exploratory_analysis: 'Exploration Analysis',
  dbl_myAnalysis_can_not_delete_chart_title: "Unable to delete.",
  dbl_myAnalysis_can_not_delete_chart_message: "The current chart is being referenced. Please cancel the chart reference before deleting.",
  dbl_myAnalysis_sure_to_delete_chart_title: "Delete Chart?",
  dbl_myAnalysis_sure_to_delete_dashboard_title: "Delete Dashboard?",
  dbl_myAnalysis_sure_to_unpublish_dashboard_title: "Do you want to unpublish Dashboard?",
  dbl_myAnalysis_sure_to_unpublish_dashboard_message: "After being unpublished, the dashboard will be removed from the Dashboard system.",
  dbl_myAnalysis_sure_to_delete_chart_message: "Delete {name}? Deletion is irreversible, please proceed with caution.",
  dbl_myAnalysis_chart_search_placeholder: "Search by chart name, creator, or data source",
  dbl_myAnalysis_chart_i_know: "I know",
  dbl_myAnalysis_top_others: 'Show the top values and aggregate the rest into "Others". ',
  dbl_myAnalysis_top: "Show the top  values only.",
  dbl_myAnalysis_limit_100: "The range of values: 1-100",
  dbl_myAnalysis_limit_500: "The range of values: 1-500",
};